import React from "react";
import styleClasses from "./career.module.scss";
import hospitality from "../../../src/images/Career/teamJobMobile1.png";
import culinary from "../../../src/images/Career/teamJobMobile2.png";
import leadership from "../../../src/images/Career/teamJobMobile3.png";
import catering from "../../../src/images/Career/teamJobMobile4.png";
import * as CONSTANT from "../../constants";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "../../images/svgIcons/svg";

const teamJobsArray = [
  {
    image: hospitality,
    title: "Hospitality",
    content: "Interact & serve",
    href: "/hospitality-team",
  },
  {
    image: culinary,
    title: "culinary",
    content: "Work With Real Food",
    href: "/culinary-team",
  },
  {
    image: leadership,
    title: "leadership",
    content: "Lead Restaurants & People",
    href: "/leadership-team",
  },
  {
    image: catering,
    title: "catering",
    content: "cater any & all events",
    href: "/catering-team",
  },
];

const TeamJobsMobile = () => {
  return (
    <div className={styleClasses.teamJobsMobileWrapper}>
      {teamJobsArray.map((data) => {
        return (
          <Link
            to={data.href}
            className="d-flex justify-content-between align-items-center border-bottom py-3 text-decoration-none">
            <div className="d-flex align-items-center gap-3">
              <img
                src={data.image}
                alt="img"
                className={`img-fluid ${styleClasses.TjMobileImg}`}
              />
              <h2
                className={`f-s20 f-w7 clr-dark-grey font-Trade-bold text-capitalize mb-0  ${styleClasses.heading}`}>
                {data.title}
              </h2>
            </div>
            <div className={styleClasses.iconDiv}>
              <ArrowRightIcon />
            </div>
          </Link>
        );
      })}
      <div className="text-center mt-4">
          <a
            href={CONSTANT.CAREERS_APPLY_ROUTE_URL}
            target="blank"
            className={`text-decoration-none color-white f-w7 font-Visby-cf text-uppercase f-sm-s14 btn btn-large mt-0 mt-md-4 ${styleClasses.careerBtns}`}>
            view all jobs
          </a>
      </div>
    </div>
  );
};
export default TeamJobsMobile;
